import { createClient } from '@supabase/supabase-js';

// Get Supabase URL from environment
const getSupabaseUrl = () => {
  const url = import.meta.env.VITE_SUPABASE_URL;
  
  if (!url) {
    throw new Error(
      'VITE_SUPABASE_URL environment variable is not set. ' +
      'Please configure your environment variables.'
    );
  }
  
  // Validate URL format
  try {
    new URL(url);
  } catch (error) {
    throw new Error(`Invalid VITE_SUPABASE_URL: ${url}`);
  }
  
  return url;
};

// Get Supabase anon key from environment
const getSupabaseAnonKey = () => {
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  
  if (!key) {
    throw new Error(
      'VITE_SUPABASE_ANON_KEY environment variable is not set. ' +
      'Please configure your environment variables.'
    );
  }
  
  // Clean any whitespace or newlines
  return key.trim();
};

const supabaseUrl = getSupabaseUrl();
const supabaseAnonKey = getSupabaseAnonKey();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
  global: {
    headers: {
      apikey: supabaseAnonKey,
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Helper function to get current user
export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) {
      // Use proper logging in production
      if (import.meta.env.DEV) {
        console.error('Error fetching user:', error);
      }
      return null;
    }
    return user;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Unexpected error in getCurrentUser:', error);
    }
    return null;
  }
};

// Helper function to sign out
export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) {
      if (import.meta.env.DEV) {
        console.error('Error signing out:', error);
      }
      throw error;
    }
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Unexpected error in signOut:', error);
    }
    throw error;
  }
};
